<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
      

        <b-button block v-b-toggle.privacy-section-8
          class="text-left fw-500 d-flex align-items-center justify-content-between">
              <div>
                  <span class="box-numbering">08</span>
                  <span>Cookies and Tracking Technologies</span>    
              </div>
              <span 
                  class="toggle-icon" 
                  :class="{ active: isOpen }"
              >
                  <span class="plus">+</span>
                  <span class="cross">×</span>
              </span> 
          </b-button>

      </b-card-header>
      <b-collapse
        id="privacy-section-8"
        visible
        accordion="my-accordion"
        role="tabpanel"
        @show="isOpen = true"
        @hide="isOpen = false"
      >
        <b-card-body>
          <p class="text-justify">
            Cookies and Tracking Technologies Our website and services use
            cookies and similar technologies to enhance user experience, analyze
            site traffic, and track user interactions. You can control your
            cookie preferences through your browser settings.
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "section-8",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isOpen: true
    };
  },
  props:['companyName']
};
</script>
